import { analyticsTrafficType } from "@tabbio/utils/analytics/browser-cookies";
import { PRIVACY_NOTICE_VERSION } from "@tabbio/utils/analytics/consent";
import {
  parseGaClientId,
  parseGaSessionId,
  readCookieValue,
  gaStreamCookieName,
} from "@tabbio/utils/analytics/attribution";
import { parseMeasurementContext } from "@tabbio/utils/analytics/measurement-context";
import { isPrivateAnalyticsPath } from "@tabbio/utils/analytics/privacy";
import { isProductAnalyticsEnabled } from "./privacy-preferences";
import { browserMeasurement } from "./browser-measurement.web";

/** A consent-qualified snapshot taken when the request is created, never at flush. */
export function getBrowserMeasurementContext(): string | null {
  if (
    typeof window === "undefined" ||
    !isProductAnalyticsEnabled() ||
    isPrivateAnalyticsPath(window.location.href)
  )
    return null;
  try {
    const gaClientId =
      parseGaClientId(readCookieValue(document.cookie, "_ga")) ?? undefined;
    const gaSessionId = gaClientId
      ? (parseGaSessionId(
          readCookieValue(document.cookie, gaStreamCookieName("G-97E51FQ4PY")),
        ) ?? undefined)
      : undefined;
    const context = parseMeasurementContext(
      JSON.stringify({
        version: 1,
        noticeVersion: PRIVACY_NOTICE_VERSION,
        capturedAt: new Date().toISOString(),
        surface: "app_web",
        trafficType: analyticsTrafficType(document.cookie),
        gaClientId,
        gaSessionId,
        postHogSessionId: browserMeasurement.sessionId(),
      }),
    );
    return context ? JSON.stringify(context) : null;
  } catch {
    return null;
  }
}
